<div class="flex items-center gap-6 w-full">
  @for (step of steps; track step.index; let last = $last) {
    <button
      (click)="stepChange.emit(step.index)"
      [class]="step.index === currentStep
        ? 'bg-gray-100 border-gray-200'
        : 'bg-white border-gray-200 cursor-pointer'"
      class="flex-1 flex items-center gap-3 p-4 rounded-lg border min-w-0">
      <!-- Icon container -->
      <div class="flex items-center justify-center w-9 h-9 rounded-lg shrink-0">
        <fa-icon
          [class]="isStepReached(step.index) ? 'text-gray-500' : 'text-gray-300'"
          [icon]="step.icon"
          class="text-base">
        </fa-icon>
      </div>
      <!-- Text -->
      <div class="flex flex-col gap-0.5 min-w-0 text-left">
        <span
          [class]="isStepReached(step.index) ? 'text-gray-500' : 'text-gray-300'"
          class="text-base font-medium leading-5 truncate">
          {{ step.title }}
        </span>
        <span
          [class]="isStepReached(step.index) ? 'text-gray-500' : 'text-gray-300'"
          class="text-sm font-normal leading-5 truncate">
          {{ step.subtitle }}
        </span>
      </div>
      <!-- Warn-Markierung bei fehlenden Pflichtangaben -->
      @if (isStepInvalid(step.index)) {
        <fa-icon
          [icon]="faTriangleExclamation"
          class="text-yellow-500 text-base shrink-0 ml-auto"
          tooltip="In diesem Schritt fehlen Pflichtangaben"
          tooltipDirection="top"></fa-icon>
      }
    </button>
    @if (!last) {
      <fa-icon
        [class]="isStepReached(step.index + 1) ? 'text-gray-500' : 'text-gray-300'"
        [icon]="faArrowRight"
        class="text-base shrink-0"></fa-icon>
    }
  }
</div>
